<template>
  <title>Star</title>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.42292 3.38745C9.63642 2.87415 10.3636 2.87415 10.5771 3.38746L12.2339 7.37101C12.3239 7.5874 12.5274 7.73526 12.7611 7.75399L17.0616 8.09876C17.6158 8.14319 17.8405 8.83476 17.4183 9.19643L14.1417 12.0032C13.9637 12.1556 13.886 12.3949 13.9404 12.6228L14.9414 16.8195C15.0704 17.3602 14.4821 17.7877 14.0077 17.4979L10.3258 15.249C10.1258 15.1268 9.87423 15.1268 9.67422 15.249L5.99232 17.4979C5.51788 17.7877 4.9296 17.3602 5.05859 16.8195L6.05965 12.6228C6.11403 12.3949 6.03629 12.1556 5.8583 12.0032L2.58171 9.19643C2.1595 8.83476 2.38421 8.14319 2.93837 8.09876L7.23894 7.75399C7.47256 7.73526 7.67607 7.5874 7.76607 7.37101L9.42292 3.38745Z"
      stroke-width="1.875"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg path {
  stroke: var(--color-icon-primary);
}
</style>
